"use client";

import React from "react";
import Image from "../../assets/images/Transparenz.jpeg"
export function RobustInfra() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 ">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[40px] lg:text-[40px] max-w-[500px] sm: text-xl text-bold">
            Robuste Infrastruktur- und Netzwerksicherheitslösungen für den Schutz Ihres Unternehmens

            </h1>
            <p className="mb-6 md:mb-8 md:text-md sm:text-sm">
            In der heutigen digitalen Landschaft ist der Schutz Ihres Netzwerks von entscheidender Bedeutung. Unsere umfassenden Lösungen sorgen dafür, dass Ihre Infrastruktur vor sich entwickelnden Bedrohungen geschützt bleibt.

            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <div className="mb-3 md:mb-4">
                  <img
                    src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                    className="size-12"
                    alt="Relume logo 1"
                  />
                </div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  Firewalls
                </h6>
                <p className="max-w-[240px]">
                Fortschrittliche Firewalls schützen Ihr Netzwerk, indem sie den ein- und ausgehenden Datenverkehr effektiv filtern.

                </p>
              </div>
              <div>
                <div className="mb-3 md:mb-4">
                  <img
                    src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                    className="size-12"
                    alt="Relume logo 1"
                  />
                </div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                E-Mail-Schutz

                </h6>
                <p className="max-w-[240px]">
                Unsere E-Mail-Schutzlösungen verhindern Phishing-Angriffe und schützen sensible Informationen.
                </p>
              </div>
            </div>
          </div>
          <div>
            <img
              src={Image}
              className="w-full h-150 object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
